module.exports = __webpack_public_path__ + "media/EBC-background-4M-en.730d65d8.mp4";